/* eslint-disable max-len */
import React from "react";

interface SVGRProps {
  title?: string;
  titleId?: string;
}

const Pinterest = ({
    title,
    titleId = "tm-icon-pinterest",
    ...props
}: React.SVGProps<SVGSVGElement> & SVGRProps) => (
    <svg
        {...props}
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 512 512"
        aria-hidden={!title}
        role={title ? "img" : ""}
        aria-labelledby={titleId}
        height="1em"
        width="1em"
    >
        {title ? <title id={titleId}>{title}</title> : null}
        <path d="M263 0C123 0 48 90 48 188c0 45 25 102 66 120 6 3 10 2 11-4l9-35c1-3 1-6-2-9-14-16-24-44-24-71 0-68 54-135 147-135 80 0 136 52 136 127 0 84-45 142-103 142-32 0-55-25-48-56 9-37 27-77 27-104 0-24-13-43-41-43-32 0-59 32-59 75 0 28 10 46 10 46l-38 154c-10 42 1 108 2 114 1 3 4 4 6 1a403 403 0 0073-173c11 19 42 35 75 35 98 0 169-86 169-193C464 77 376 0 263 0z" />
    </svg>
);

export default Pinterest;
